import { Cancel, Edit, Save } from "@mui/icons-material"
import { Box } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"

type CardActionButtonProps = {
  isEdit: boolean
  setIsEdit: (arg: boolean) => void
  handleCancel: () => void
  form: string
}

export const CardActionButton = (props: CardActionButtonProps) => {
  const { isEdit, setIsEdit, handleCancel, form } = props

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      {!isEdit && (
        <StyledButton
          buttonType="custom"
          customIcon={<Edit fontSize="small" />}
          onClick={() => setIsEdit(true)}
          size="small"
          variant="contained"
        />
      )}
      {isEdit && (
        <>
          <StyledButton
            buttonType="custom"
            customIcon={<Cancel fontSize="small" />}
            onClick={handleCancel}
            size="small"
            variant="contained"
          />
          <StyledButton
            buttonType="custom"
            customIcon={<Save fontSize="small" />}
            form={form}
            type="submit"
            size="small"
            variant="contained"
          />
        </>
      )}
    </Box>
  )
}
